import React, { useCallback, useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PayModel from "./pay";
import VerifyModal from "./verifyIdentitty";
import AgreementModal from "./signAgreement";
import SubscriptionModal from "./proSubscription";
import ApplicationModal from "./channelApplication";
import { useAuth } from "../../../context/AuthContext";
import { setDoc, doc } from "firebase/firestore";

import { getUser } from "../../../api/accounts/userServices";
import { useNavigationBar } from "../../../context/NavigationContext";
import { CreateChannelContext } from "../../../context/CreateChannelContext";
import APILoader from "../../../components/APILoader";
import { ChannelType } from "../../../models/SKChannel";
import { ApplicationState } from "../../../models/SKApplication";
import { SKUser } from "../../../models/SKUser";
import { COLLECTIONS } from "../../../firebase/firebase";

const checks = [
  {
    title: "Channel Application",
    desc: "Channel application lets us learn about you and the content you plan to publish.",
    linkTitle: "Start Channel Application",
    doneTitle: "Channel Application Approved",
    to: "submit-application",
  },
  // {
  //   title: "Enrollment Fee",
  //   desc: "Enrollment fee is a one time non-refundable fee to get your onboarding process started.",
  //   linkTitle: "Pay Enrollment Fee",
  //   doneTitle: "Enrollment Fee Paid",
  //   to: "pay",
  // },
  // {
  //   title: "Identity Verification",
  //   desc: "ID verification helps us to keep the product safe and verify who you are.",
  //   linkTitle: "Verify Identity",
  //   doneTitle: "Verification Successful",
  //   to: "verify-identity",
  // },

  {
    title: "Terms and Agreements",
    desc: "Review and sign Terms of Service, Privacy Policy, Community Guidelines, and other agreements.",
    linkTitle: "Review and Sign",
    doneTitle: "Reviewed and Signed",
    to: "sign-agreement",
  },
  // {
  //   title: "Pro Subscription",
  //   desc: "Pro subscription allows you to publish content and get support.",
  //   linkTitle: "Sign Up for Pro Subscription",
  //   doneTitle: "Pro Subscription Active",
  //   to: "pro-subscription",
  // },
  {
    title: "Channel Information",
    desc: "Setup your channel to start publishing content.",
    linkTitle: "Create Channel",
    to: "create-channel",
  },
];

const Checklist = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [showPay, setShowPay] = useState(false);
  const [showSubscription, setShowSubscription] = useState(false);
  const [showAgreement, setShowAgreement] = useState(false);
  const [showApplicationn, setShowApplication] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [channelType, setChannelType] = useState<string | undefined>(undefined);
  const { setNavProps } = useNavigationBar();
  const { channelData, loading } = useContext(CreateChannelContext);
  const [locationState, setLocationState] = useState<any | undefined>(undefined);
  const location = useLocation();
  const [appUser, setAppUser] = useState<SKUser | undefined>(undefined);
  const [appStatus, setAppStatus] = useState<ApplicationState | undefined>(undefined);

  useEffect(() => {
    if (locationState === location.state) {
      return;
    }
    setLocationState(location.state);
    setNavProps({
      backArrow: false,
      title: "Onboarding",
      subtitle: "Creator Onboarding",
      buttonTitle: "Create Channel",
      filterOption: false,
      enableLink: currentStep === 5 ? true : false,
      onBack: () => {
        navigate("../", { state: location.state });
      },
    });
    console.log("in Loop1");
  }, [setNavProps, currentStep, navigate]);

  useEffect(() => {
    if (channelType !== location.state?.channelType) {
      setChannelType(location.state?.channelType);
    }
    if (ApplicationState.SUBMITTED === location.state?.status) {
      setAppStatus(ApplicationState.SUBMITTED);
      return;
    }
    console.log("in Loop2");
  }, [location]);

  const authContext = useAuth();

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (!authContext?.currentUser) {
        return;
      }
      //let ref = doc(authContext.db, COLLECTIONS.USERS, authContext.currentUser?.uid);
      // Create a reference to the user document
      const user = await getUser(authContext.currentUser?.uid); // Fetch the document
      setAppUser(user);
      if (user) {
        if (user.onboarding) {
          if (user.onboarding.applicationStatus === ApplicationState.APPROVED) {
            // if (user.onboarding.application) {
            setCurrentStep(1);
            // }
          }
          // if (user.onboarding.payment) {
          //   setCurrentStep(2);
          // }
          // if (user.onboarding.verification) {
          //   setCurrentStep(3);
          // }
          if (user.onboarding.aggreement) {
            setCurrentStep(2);
          }
          // if (user.onboarding.subscription) {
          //   setCurrentStep(5);
          // }
        }
      } else {
        console.log("No such document!");
        return null; // Handle the case where the document does not exist
      }
    };
    // if (!authContext?.currentUser) {
    fetchUserInfo();
    console.log("in Loop3");
    // }
  }, [authContext]);

  let element = <img src={"/icons/check.png"} className="w-[16px] h-[16px] rounded-lg" alt="" />;

  const moveNext = (e: React.FormEvent) => {
    e.preventDefault();
    if (currentStep === checks.length - 1) {
      navigate("/dashboard/channels/onboard", { state: { channelType: ChannelType.creator } });
    }
    // setCurrentStep(currentStep + 1);

    switch (currentStep) {
      case 0:
        navigate("application");
        // setShowApplication(true);
        break;
      // case 1:
      //   window.location.href = `https://buy.stripe.com/test_bIY3fiagi1BV62I6oo?client_reference_id=${authContext?.currentUser?.uid}&prefilled_email=${authContext?.currentUser?.email}`;
      //   break;
      // case 2:
      //   window.location.href = `https://verify.stripe.com/v/28odUPciCcjCe3u6oo?client_reference_id=${authContext?.currentUser?.uid}&prefilled_email=${authContext?.currentUser?.email}`;
      //   // setShowVerify(true);
      //   break;
      case 1:
        setShowAgreement(true);
        break;
      // case 4:
      //   setShowSubscription(true);
      //   break;
      default:
        break;
    }
  };

  // useEffect(() => {

  // }, [currentStep])

  const updateObject = async (obj: any) => {
    if (!authContext?.currentUser) {
      return;
    }
    // await setDoc(doc(db, COLLECTIONS.USERS, auth.currentUser.uid), { email, firstName, lastName, phone }, { merge: true });
    // let ref = doc(authContext.db, COLLECTIONS.USERS, authContext.currentUser?.uid);
    await setDoc(doc(authContext.db, COLLECTIONS.USERS, authContext.currentUser?.uid), obj, { merge: true });
  };

  const onSubscriptionDone = async () => {
    setShowSubscription(false);
    await updateObject({ onboarding: { subscription: true } });
    setCurrentStep(prevData => prevData + 1);
  };

  const verificationDone = async () => {
    setShowVerify(false);
    await updateObject({ onboarding: { verification: true } });
    setCurrentStep(prevData => prevData + 1);
  };
  const applicationDone = async () => {
    setShowApplication(false);
    await updateObject({ onboarding: { application: true } });
    setCurrentStep(prevData => prevData + 1);
  };
  const agreementDone = async () => {
    setShowAgreement(false);
    await updateObject({ onboarding: { aggreement: true } });
    setCurrentStep(prevData => prevData + 1);
  };
  const onPaymentDone = async () => {
    setShowPay(false);
    const userType = channelData.channelType;
    await updateObject({ onboarding: { payment: true }, userType });
    setCurrentStep(prevData => prevData + 1);
  };

  const getApplicationLinkTitle = useCallback(() => {
    if (appUser) {
      switch (appUser.onboarding?.applicationStatus) {
        case ApplicationState.APPROVED:
          return "Application Approved";
        case ApplicationState.DRAFT: // DRAFT
          return "Edit Channel Application";
        case ApplicationState.REJECTED:
          return "Application Rejected";
        case ApplicationState.SUBMITTED:
          return "In Review...";
      }
    }
    if (appStatus === ApplicationState.SUBMITTED) {
      return "In Review...";
    }

    return "Start Channel Application";
  }, [appUser, appStatus]);

  const getApplicationTextColor = useCallback(() => {
    if (appUser) {
      switch (appUser.onboarding?.applicationStatus) {
        case ApplicationState.APPROVED:
          return "text-skgreen";
        case ApplicationState.DRAFT: // DRAFT
          return "text-[#000000]";
        case ApplicationState.REJECTED:
          return "text-skred";
        case ApplicationState.SUBMITTED:
          return "text-[#8E8E93]";
      }
    }
    return "text-[#000000]";
  }, [appUser]);

  return (
    <div className="pb-20 channel-page-context">
      <APILoader loading={loading} />
      <div className="flex flex-col">
        {/* <div className="flex flex-row px-5 py-2 h-[50px] w-full justify-between">
          <div className="float-left text-2xl font-bold">Onboarding</div>
          <div className="float-right">
            <Link
              to="../create"
              className="flex items-center justify-center px-2 py-1 text-lg font-normal text-center text-white bg-black rounded-lg"
            >
              <button className="w-full h-full">Next</button>
            </Link>
          </div>
        </div> */}

        <AgreementModal isOpen={showAgreement} agreementDone={agreementDone} />
        {/* <ApplicationModal isOpen={showApplicationn} applicationDone={applicationDone} /> */}
        <PayModel isOpen={showPay} onPaymentDone={onPaymentDone} />
        <SubscriptionModal isOpen={showSubscription} onSubscriptionDone={onSubscriptionDone} />
        <VerifyModal isOpen={showVerify} verificationDone={verificationDone} />

        {/* <div className="w-full my-2 thickseparator" /> */}
        <div className="flex flex-col w-full">
          <div className="flex pb-[15px] pt-[15px]">
            <span className="content_title">Complete the following steps to create your channel and start publishing. </span>
          </div>
          <div className="flex flex-col gap-[15px] w-full">
            {checks.map((data, index) => (
              <div key={index} className="flex flex-col p-[20px] bg-white border-[1px] rounded-[18px] border-gray max-w-[550px] max-h[149px]">
                <div className="flex flex-row">
                  <div
                    className={
                      (currentStep === index
                        ? " text-white bg-black "
                        : currentStep > index
                        ? " bg-skgreen "
                        : " text-skgray bg-white border-2 border-gray text-[18px] leading-[23.4px] flex font-roboto font-bold tracking-[0.36px] ") +
                      "text-[18px] leading-[23.4px] flex font-roboto font-bold tracking-[0.36px] items-center justify-center flex-shrink-0 w-[30px] h-[30px] rounded-full"
                    }
                  >
                    {currentStep > index ? element : index + 1}
                  </div>
                  <div className="flex flex-col w-full pl-[20px]">
                    <label
                      className={
                        currentStep === index
                          ? " text-[#000000] channel-checklist-title"
                          : currentStep > index
                          ? "text-[#8E8E93] channel-checklist-title"
                          : "text-[#8E8E93] channel-checklist-title"
                      }
                    >
                      {data.title}
                    </label>
                    <p
                      className={
                        currentStep === index ? " text-[#000000] channel-checklist-sub-title" : " text-[#8E8E93] channel-checklist-sub-title"
                      }
                    >
                      {data.desc}
                    </p>
                    <div className="w-full thinseparator mt-[15px] mb-[15px]" />
                    {currentStep === index && appUser?.onboarding?.applicationStatus !== ApplicationState.REJECTED ? (
                      <Link to={data.to} onClick={moveNext} className="float-left py-2 text-black text-[16px]">
                        {index === 0 ? getApplicationLinkTitle() : data.linkTitle}
                      </Link>
                    ) : (
                      <div
                        className={
                          (index === 0 ? ` ${getApplicationTextColor()}` : currentStep > index ? " text-skgreen" : " text-[#8E8E93]") +
                          " channel-checklist-bottom-title"
                        }
                      >
                        {index === 0 ? getApplicationLinkTitle() : currentStep > index ? data.doneTitle : data.linkTitle}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checklist;
